import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";
import { useIsMobile } from "@/hooks/use-mobile";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();
  const isMobile = useIsMobile();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      /* Mobile toasts must NOT render over the header: on iOS/WKWebView a
         top-center toast sits exactly on top of the hamburger trigger and
         swallows the first tap right after login (the toast is gone by the
         time the user navigates away and back — which is why the second
         visit "worked"). Bottom-center keeps the header always tappable. */
      position={isMobile ? "bottom-center" : "bottom-left"}
      offset={isMobile ? "16px" : undefined}
      mobileOffset={{ bottom: "24px", left: "12px", right: "12px" }}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
